import React from 'react';

export default () => {
  return (
    <>
      <p className="s-copywriter-editor__text s-copywriter-editor__text_gray s-copywriter-editor__text_semi-bold">
        {i18n.t('assistant.empty_result.header')}
      </p>
      <p className='s-copywriter-editor__text s-copywriter-editor__text_gray'>
        {i18n.t('assistant.empty_result.type')}
        <span className="s-copywriter-editor__text_medium"> {i18n.t('assistant.empty_result.prompt')} </span>
        {i18n.t('assistant.empty_result.click')}
        <span className="s-copywriter-editor__text_medium"> {i18n.t('assistant.empty_result.generate')}</span>
      </p>
    </>
  );
};
